import React from 'react'
import "../CSS/journey.css";
function Journey() {
    return (
        <div className="journey">
            <div className="journey-step">
                <div className="journey-step1">
                    <div className="top">
                        <img  src="https://media.discordapp.net/attachments/445928139021877259/1180914876852486234/Component_8.png?ex=657f27ae&is=656cb2ae&hm=e43a68d3ceb5d369b983c65d9a06f696d39fc9471e7d126579975829991d3071&=&format=webp&quality=lossless" alt='co2-decrease'/>
                    </div>
                    <div className="bottom">เรามุ่งมั่นที่จะลดการปล่อยก๊าซคาร์บอนไดออกไซด์และส่งเสริมระบบอาหารที่ยั่งยืนมากขึ้น ด้วยการจัดหาส่วนผสมที่สดใหม่จากธรรมชาติ เรากำลังมีบทบาทอย่างแข็งขันในการอนุรักษ์โลก
                    สำหรับคนรุ่นอนาคตด้วย<br /> <b>"เนื้อจากพืช"</b></div>
                </div>
                <div className="journey-step2">
                    <div className="top">
                        <img src="https://media.discordapp.net/attachments/445928139021877259/1180914877049622568/Component_9.png?ex=657f27af&is=656cb2af&hm=b6ecafb88bf81cad39538a9353b7da23eb14ce04f096e900a6d79a6054832082&=&format=webp&quality=lossless" alt='animal-care'/>
                    </div>
                    <div className="bottom">ผลิตภัณฑ์เนื้อพืชของเราปราศจากความโหดร้าย 100% ส่งเสริมระบบอาหารที่มีความเห็นอกเห็นใจมากขึ้น ซึ่งเป็นมิตรกับสัตว์และสิ่งแวดล้อมมากขึ้น เราเชื่อในการปฏิบัติต่อสิ่งมีชีวิตทั้งหมดด้วยความเมตตาและความเคารพ</div>
                </div>
                <div className="journey-step3">
                    <div className="top">
                        <img src="https://cdn.discordapp.com/attachments/445928139021877259/1180914877250940999/Component_10.png?ex=657f27af&is=656cb2af&hm=2b49327d1aaa3d89a2739492f87be46069a937a092c0bd9f47990a4aad7455d4&" alt='world-peace'/>
                    </div>
                    <div className="bottom">เรามุ่งมั่นที่จะสร้างผลิตภัณฑ์จากพืชของเราไม่เพียง
                    แต่มีจริยธรรมและยั่งยืน แต่ยังอร่อยและสนุกสนาน
                    สำหรับทุกคนอีกด้วยเป้าหมายของเราคือการทำให้
                    ไลฟ์สไตล์ที่เน้นพืชเป็นหลักเป็นตัวเลือกที่น่าตื่นเต้น
                    ได้ลิ่มลองประสบการณ์ใหม่ๆที่คุณไม่เคยพบเจอที่ไหน
                    และเข้าถึงได้ ซึ่งจะนำความสุขมาสู่ชีวิตของผู้คน เหมาะกับ <br></br><b>"การกินที่เน้นพืชเป็นหลัก"</b></div>
                </div>
            </div>
        </div>
    )
}

export default Journey